import { axiosInstance } from '@/modules/shared/lib/axios';
import { UserMutationResponse } from './types';

type Props = {
  companyId: string
  userIdToRemove: string
}

export function removeAdminUser ({ companyId, userIdToRemove }: Props) {
    return axiosInstance.delete<UserMutationResponse>(
        `/config-api/${companyId}/configuration/admin/users/${userIdToRemove}`
    );
}
